import React, { Component } from 'react'
import { Field } from 'redux-form'

import './HomeOfficeSize.scss'
import HomeOfficeSelector from '../HomeOfficeSelector'
import RoomCounter from '../RoomCounter'

class HomeOfficeSize extends Component {
  render () {
    return (
      <div className='HomeOfficeSize'>
        <fieldset>
          <legend>Tamaño de tu casa</legend>

          <div className='HomeOfficeSize-Counter'>
            <p>Número de habitaciones</p>
            <Field
              name='rooms'
              component={RoomCounter}
              key='rooms'
              min={1}
              max={10} />
          </div>

          <div className='HomeOfficeSize-Counter'>
            <p>Número de baños</p>
            <Field
              name='bathrooms'
              component={RoomCounter}
              min={1}
              max={10} />
          </div>
        </fieldset>
      </div>
    )
  }
}

HomeOfficeSize.displayName = 'HomeOfficeSize'
HomeOfficeSize.propTypes = {}
HomeOfficeSize.defaultProps = {}

export default HomeOfficeSize



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/LocationForm/components/HomeOfficeSize/HomeOfficeSize.js